import React, { useState} from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import {Box,Typography,Button, FormControl,Snackbar} from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import AccountCircle from '@mui/icons-material/AccountCircle';
import DialogContent from '@mui/material/DialogContent';
import InputBase from '@mui/material/InputBase';
import {IconButton} from "@mui/material"
import {useSelector, useDispatch} from 'react-redux';
import {useTheme, alpha,styled } from '@mui/material/styles'
import {login} from "../Redux/authSlice"
import UserInput from './UserInput'
import ItemView from './ItemView'
import axios from 'axios'
import { CopyAll, Edit, Visibility, VisibilityOff } from '@mui/icons-material';

const CustomFileInput = styled('input')(({ theme }) => ({
    display: 'none',
    '& + label': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(1),
    cursor: 'pointer',
    borderRadius: 10,
    '&:hover': {
        backgroundColor: '#192f6a',
    },
    
    },
}));

const ProfileDialog = ({visible,setVisible})=>{

    const theme = useTheme()
    const user = useSelector(state => state?.auth.user);
    const size_sm = useMediaQuery(theme.breakpoints.up('sm'));
    const [email,setEmail] = useState(user?.email)
    const [first_name,setFirst_name] = useState(user?.first_name)
    const [edited,setEdited] = useState("")
    const [editing,setEditing] = useState(false)
    const [showEdited,setShowEdited] = useState(false)
    const [submitting,setSubmitting] = useState(false)
    const [last_name,setLast_name] = useState(user?.last_name)
    const [picture,setPicture] = useState(user?.profile)
    const [password,setPassword] = useState("")
    const [organization,setOrganization] = useState(user?.organization)
    const dispatch = useDispatch()
    const [selectedFile, setSelectedFile] = useState(user?.profile ? user?.profile : null);
    const [selected, setSelected] = useState(false);
    const [show, setShow] = useState(true);
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState("");


const handleFileChange = (event) => {
    const file = event?.target?.files[0];
    setSelectedFile(file);
//   console.log(URL.createObjectURL(file))
    setSelected(true)
    setShowEdited(true)
};

const handleClearSelection = () => {
    setSelectedFile(user?.profile ? user?.profile : "");
    setSelected(false)
};

const onClose = () => {
    setVisible(false);
};

const handleEdit = async ()=>{
    try {
        if (password !== "") {

            setSubmitting(true)
            setEditing(true)

            if (selected) {

                let formData = new FormData()

                formData.append("file",selectedFile)
                formData.append("first_name",first_name)
                formData.append("last_name",last_name)
                formData.append("email",user?.email)
                formData.append("password",password)
                formData.append("organization",organization)
                formData.append("profile",user?.url || "https://")

                    const editUser = await axios.put(`${process.env.REACT_APP_SOCKET_URL}api/edit/user/edit-user`,formData,{
                           headers:{
                                  "Content-Type":"multipart/form-data",
                                  "Authorization":`Bear ${user?.accessToken}`
                              }
                       }).catch(err=>{
                        console.log(err)
                    })

                    if (editUser?.status == 200 && editUser?.data?.success == true) {
                        
                        setVisible(false)
                        setMessage("your profile data has been edited")
                        setOpen(true)
            
                        const newUserData = {
                            ...user,
                            last_name:editUser?.data?.user.last_name,
                            first_name:editUser?.data?.user.first_name,
                            organization:editUser?.data?.user.organization,
                            profile:editUser?.data?.user.picture
                        }
            
                        setPassword("")
                        dispatch(login(newUserData))
                        setEditing(false)
                        setShowEdited(false)
                        setSelected(false)
                        setSubmitting(false)
            
                    } else {
                        setMessage(editUser?.data.message)
                        setOpen(true)
                        setSubmitting(false)
                    }
                    
                }
                else{

                const send_data = {
                    first_name:first_name,
                    last_name:last_name,
                    email:user?.email,
                    password:password,
                    organization:organization,
                    profile:user?.url || "https://"

                }
        
                const editUser = await axios.put(`${process.env.REACT_APP_SERVER_AUTH_URL}edit-user`,send_data,{
                       headers:{
                              "Content-Type":"application/json",
                              "Authorization":`Bear ${user?.accessToken}`
                          }
                   }).catch(err=>{
                    console.log(err)
                })

                if (editUser?.status == 200 && editUser?.data?.success == true) {
                    setVisible(false)
                    setMessage("your profile data has been edited")
                    setOpen(true)
        
                    const newUserData = {
                        ...user,
                        last_name:editUser?.data?.user.last_name,
                        first_name:editUser?.data?.user.first_name,
                        organization:editUser?.data?.user.organization,
                        profile:editUser?.data?.user.picture
                    }
                    setPassword("")
                    dispatch(login(newUserData))
                    setEditing(false)
                    setShowEdited(false)
                    setSelected(false)
                    setSubmitting(false)
        
                } else {
                    setMessage(editUser?.data.message)
                    setOpen(true)
                    setEditing(false)
                    setShowEdited(false)
                    setSelected(false)
                    setSubmitting(false)
                }
            }
    
        } else {
            setMessage("Please,write down your password")
            setOpen(true)
        }

    } catch (error) {
        console.log(error)
        setMessage("error while sending")
        setOpen(true)
        setEditing(false)
        setSubmitting(false)
    }
}


return(    
    <Dialog open={visible} onClose={onClose} sx={{borderRadius:10,justifyContent:"center",textAlign:"center"}}>
        <DialogTitle sx={{background:theme.palette.background.default}}> 
            <Box width="90%" display="flex" flexDirection="row" justifyContent="flex-start" alignContent="center">
                <IconButton sx={{marginTop:3}}>
                    <MenuIcon/>
                </IconButton>					
                <Typography mr={2} mt={4} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans",color:"gold"}}>
                    Profile
                </Typography>		
            </Box>
        </DialogTitle>
        <DialogContent m={theme.spacing(1)} sx={{height:800,width:{xs:300,md:400},justifyContent:"flex-start",alignItems:"center",background:theme.palette.background.default}}>
            <Snackbar anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
                }}
                message={message} 
                onClose={()=>{setOpen(false)}} 
                open={open}
                autoHideDuration={3000}
            />
            <Box mb={2}  display="flex" flexDirection="row" sx={{height:80,justifyContent:"center",alignItems:"center"}}>
                <FormControl variant="standard">
                    <CustomFileInput id="file-input" type="file" onChange={handleFileChange} />
                    <label htmlFor="file-input">
                        {
                            (user?.profile !== "https://"  || selected ) ? 
                            <img
                                src={selected ? URL.createObjectURL(selectedFile) : {uri:user?.profile}}
                                alt="profile"
                                style={{ cursor: 'pointer',width:80,height:80,borderRadius:10 }} 
                            />
                        : user?.profile === "https://" ?
                            <IconButton sx={{background:'#fff',borderRadius:3}}  size="large" color="inherit" >
                                <img resizemode="cover" src={require("../assets/avatar.jpg")} width={50} height={50} style={{borderRadius:20,position:"relative"}}/>
                            </IconButton>
                        :  <IconButton sx={{background:'#fff',borderRadius:3}}  size="large" color="inherit" >
                                <img resizemode="cover" src={user?.profile} width={50} height={45} style={{borderRadius:20,position:"relative"}}/>
                            </IconButton>
                        }
                    </label>
                </FormControl>
            </Box>
            <Box justifyContent="flex-start" alignItems="center" width="100%">
                <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                    <ItemView title="First Name" content={user?.first_name}/>
                    <IconButton onClick={(e)=>{
                        setEdited("first_name")
                        setShowEdited((prev)=>!prev)
                    }}>
                        <Edit  fontSize='small'/>
                    </IconButton>
                </Box>
                {
                    (showEdited && edited === "first_name") && (
                        <UserInput
                            label={`First Name *`}
                            input={first_name}
                            setInput={setFirst_name}
                            isPass={false}
                        >
                            <AccountCircle/>
                        </UserInput>
                    )
                }
            </Box>
            <Box justifyContent="flex-start" alignItems="center">
                <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                    <ItemView title="Last Name" content={user?.last_name}/>
                    <IconButton onClick={(e)=>{
                        setEdited("last_name")
                        setShowEdited((prev)=>!prev)
                    }}>
                        <Edit fontSize='small'/>
                    </IconButton>
                </Box>
                {
                    (showEdited && edited === "last_name") && (
                        <UserInput
                            label={`Last Name*`}
                            input={last_name}
                            setInput={setLast_name}
                            isPass={false}
                        >
                            <AccountCircle/>
                        </UserInput>
                    )
                }                
            </Box>
            <Box justifyContent="flex-start" alignItems="center">
                <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                    <ItemView title="Email" content={user?.email}/>
                    <IconButton onClick={(e)=>{
                        navigator.clipboard.writeText(user?.email)
                        setMessage("email copied")
                        setOpen(true)
                    }}>
                        <CopyAll fontSize='small'/>
                    </IconButton>
                </Box>                
            </Box>
            <Box justifyContent="flex-start" alignItems="center">
                <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
                    <ItemView title="Organization" content={user?.organization}/>
                    <IconButton onClick={(e)=>{
                        setEdited("organization")
                        setShowEdited((prev)=>!prev)
                    }}>
                        <Edit fontSize='small'/>
                    </IconButton>
                </Box>
                {
                    (showEdited && edited === "organization") && (
                        <UserInput
                            label={`Organization *`}
                            input={organization}
                            setInput={setOrganization}
                            isPass={false}
                        >
                            <AccountCircle />
                        </UserInput>
                    )
                } 
                {
                    showEdited && (
                        <UserInput
                            label={`Password *`}
                            input={password}
                            setInput={setPassword}
                            isPass={show}
                        >
                        <IconButton onClick={()=>{
                                setShow(prev=>!prev)
                        }}>
                                {show ? <VisibilityOff fontSize='15'/> : <Visibility fontSize='15'/> }
                        </IconButton>
                        </UserInput>
                    )
                }               
            </Box>
            <Box display="flex" flexDirection="row" justifyContent="space-evenly" alignItems="center">
                <Button onClick={handleEdit} disabled={submitting  ? true : false} sx={{background:"gold",color:"black",marginTop:2,marginLeft:{sm:3,md:0},height:{xs:30,md:35},fontFamily:"dinofans",fontSize:12}} variant="contained">
                    {
                        submitting ? <CircularProgress size={20} sx={{color:"black"}}/> : "Edit"
                    }
                </Button>
                <Button sx={{background:"maroon",color:"white",marginTop:2,marginLeft:{sm:3,md:0},height:{xs:30,md:35},fontFamily:"dinofans",fontSize:12}} onClick={()=>{setVisible(false)}} variant="contained">
                    Cancel
                </Button>
            </Box>
        </DialogContent>
    </Dialog>
    )
}

export default ProfileDialog;